import { useState } from 'react';

export default function TrazabilidadPorProduccion({ Datos }) {
    const [searchEntrada, setSearchEntrada] = useState('');
    const [searchSalida, setSearchSalida] = useState('');

    const renombresProduccion = {
        sCodbar: 'QR',
        FechaProduccion: 'Fecha de Producción',
        FechaVencimiento: 'Fecha de Vencimiento',
        LoteProveedor: 'Lote',
        TipoProducto: 'Tipo de producto',
    };

    return (
        <div className="tab-content">
            {Datos?.Lote && (
                <h4 style={{ textAlign: 'center', fontSize: '1.5rem', fontWeight: 'bold', margin: '1rem 0', color: 'var(--app-brand)' }}>
                    Proceso: {Datos.Proceso}
                </h4>
            )}

            {/* Resumen de Entradas */}
            {Datos?.ListaProcesoEntrada?.length > 0 && (
                <div className="traz-resumen-container traz-resumen-entradas">
                    <h4 className="traz-resumen-title">Resumen de Entradas</h4>
                    <div className="traz-resumen-grid">
                        {Object.entries(
                            Datos.ListaProcesoEntrada.reduce((acc, item) => {
                                const key = item.MercaderiaCodigo + ' - ' + item.MercaderiaDescripcion;
                                if (!acc[key]) {
                                    acc[key] = {
                                        count: 0,
                                        peso: 0,
                                        unidadMedida: item.Unidad
                                    };
                                }
                                acc[key].count += 1;
                                acc[key].peso += parseFloat(item.Cantidad || 0);
                                return acc;
                            }, {})
                        ).map(([mercaderia, data]) => (
                            <div key={mercaderia} className="traz-resumen-item traz-resumen-entrada-item">
                                <div className="traz-resumen-mercaderia">{mercaderia}</div>
                                {data.MercaderiaCodigo && (
                                    <div className="traz-resumen-codigo">Código: {data.MercaderiaCodigo}</div>
                                )}
                                <div className="traz-resumen-stats">
                                    <span className="traz-resumen-registros">{data.count} registro(s)</span>
                                    {data.cantidad > 0 && (
                                        <span className="traz-resumen-cantidad">
                                            Cantidad: {data.cantidad.toFixed(2)} {data.unidadMedida}
                                        </span>
                                    )}
                                    {data.peso > 0 && (
                                        <span className="traz-resumen-peso">Cantidad: {parseFloat(data.peso)} {data.unidadMedida}</span>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Resumen de Salidas */}
            {Datos?.ListaProcesoSalidas?.length > 0 && (
                <div className="traz-resumen-container traz-resumen-salidas">
                    <h4 className="traz-resumen-title">Resumen de Salidas</h4>
                    <div className="traz-resumen-grid">
                        {Object.entries(
                            Datos.ListaProcesoSalidas.reduce((acc, item) => {
                                const key = item.MercaderiaCodigo + ' - ' + item.MercaderiaDescripcion;
                                if (!acc[key]) {
                                    acc[key] = {
                                        count: 0,
                                        peso: 0,
                                        unidadMedida: item.Unidad
                                    };
                                }
                                acc[key].count += 1;
                                acc[key].peso += parseFloat(item.Cantidad || 0);
                                return acc;
                            }, {})
                        ).map(([mercaderia, data]) => (
                            <div key={mercaderia} className="traz-resumen-item traz-resumen-salida-item">
                                <div className="traz-resumen-mercaderia">{mercaderia}</div>
                                {data.MercaderiaCodigo && (
                                    <div className="traz-resumen-codigo">Código: {data.MercaderiaCodigo}</div>
                                )}
                                <div className="traz-resumen-stats">
                                    <span className="traz-resumen-registros">{data.count} registro(s)</span>
                                    {data.peso > 0 && (
                                        <span className="traz-resumen-peso">Cantidad: {parseFloat(data.peso)} {data.unidadMedida}</span>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Detalle de Entradas */}
            {Datos?.ListaProcesoEntrada?.length > 0 && (
                <div className="traz-section">
                    <h3 className="traz-section-title traz-entradas-title">
                        📥 Detalle de Entradas
                    </h3>
                    <div className="codbar-search-container">
                        <input
                            type="text"
                            placeholder="Buscar en entradas..."
                            value={searchEntrada}
                            onChange={(e) => setSearchEntrada(e.target.value)}
                            className="codbar-search-input"
                        />
                    </div>
                    <div className="traz-mercaderia-list">
                        {Object.entries(
                            Datos.ListaProcesoEntrada
                                .filter(item => {
                                    if (!searchEntrada) return true;
                                    const searchLower = searchEntrada.toLowerCase();
                                    return Object.values(item).some(value =>
                                        String(value).toLowerCase().includes(searchLower)
                                    );
                                })
                                .reduce((acc, item) => {
                                    const key = item.MercaderiaCodigo + ' - ' + item.MercaderiaDescripcion;
                                    if (!acc[key]) acc[key] = [];
                                    acc[key].push(item);
                                    return acc;
                                }, {})
                        ).map(([mercaderia, items]) => (
                            <div key={mercaderia} className="traz-mercaderia-group traz-entradas-group">
                                <div className="traz-mercaderia-header">
                                    <span className="traz-mercaderia-name">{mercaderia}</span>
                                    <span className="traz-mercaderia-count">
                                        ({items.length}) - Total: {parseFloat(items.reduce((sum, item) => sum + parseFloat(item.Cantidad || 0), 0).toFixed(2))} {items[0]?.Unidad || ''}
                                    </span>
                                </div>
                                <div className="traz-items-list">
                                    {items.map((item, idx) => (
                                        <div key={idx} className="traz-item">
                                            {Object.entries(item)
                                                .filter(([key]) =>
                                                    key !== 'MercaderiaCodigo' &&
                                                    key !== 'MercaderiaDescripcion' &&
                                                    key !== 'Unidad' &&
                                                    key !== 'EsProductoTerminado'
                                                )
                                                .map(([key, value]) => {
                                                    const etiqueta = renombresProduccion[key] || key; 
                                                    return (
                                                        <div key={key} className="traz-item-row">
                                                            <span className="traz-item-key">{etiqueta}:</span>
                                                            <span className="traz-item-value">{key === 'TipoProducto' ? (value === 'ProductoTerminado' ? 'Producto terminado' : 'Materia prima / insumo') : value}</span>
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Detalle de Salidas */}
            {Datos?.ListaProcesoSalidas?.length > 0 && (
                <div className="traz-section">
                    <h3 className="traz-section-title traz-salidas-title">
                        📤 Detalle de Salidas
                    </h3>
                    <div className="codbar-search-container">
                        <input
                            type="text"
                            placeholder="Buscar en salidas..."
                            value={searchSalida}
                            onChange={(e) => setSearchSalida(e.target.value)}
                            className="codbar-search-input"
                        />
                    </div>
                    <div className="traz-mercaderia-list">
                        {Object.entries(
                            Datos.ListaProcesoSalidas
                                .filter(item => {
                                    if (!searchSalida) return true;
                                    const searchLower = searchSalida.toLowerCase();
                                    return Object.values(item).some(value =>
                                        String(value).toLowerCase().includes(searchLower)
                                    );
                                })
                                .reduce((acc, item) => {
                                    const key = item.MercaderiaCodigo + ' - ' + item.MercaderiaDescripcion;
                                    if (!acc[key]) acc[key] = [];
                                    acc[key].push(item);
                                    return acc;
                                }, {})
                        ).map(([mercaderia, items]) => (
                            <div key={mercaderia} className="traz-mercaderia-group traz-salidas-group">
                                <div className="traz-mercaderia-header">
                                    <span className="traz-mercaderia-name">{mercaderia}</span>
                                    <span className="traz-mercaderia-count">
                                        ({items.length}) - Total: {items.reduce((sum, item) => sum + parseFloat(item.Cantidad || 0), 0)} {items[0]?.Unidad || ''}
                                    </span>
                                </div>
                                 <div className="traz-items-list">
                                    {items.map((item, idx) => (
                                        <div key={idx} className="traz-item">
                                            {Object.entries(item)
                                                .filter(([key]) =>
                                                    key !== 'MercaderiaCodigo' &&
                                                    key !== 'MercaderiaDescripcion' &&
                                                    key !== 'Unidad' &&
                                                    key !== 'EsProductoTerminado'
                                                )
                                                .map(([key, value]) => {
                                                    const etiqueta = renombresProduccion[key] || key; 
                                                    return (
                                                        <div key={key} className="traz-item-row">
                                                            <span className="traz-item-key">{etiqueta}:</span>
                                                            <span className="traz-item-value">{key === 'TipoProducto' ? (value === 'ProductoTerminado' ? 'Producto terminado' : 'Materia prima / insumo') : value}</span>
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {(!Datos?.ListaProcesoEntrada || Datos.ListaProcesoEntrada.length === 0) &&
                (!Datos?.ListaProcesoSalidas || Datos.ListaProcesoSalidas.length === 0) && (
                    <div className="traz-no-data">
                        <p>No hay datos de entradas ni salidas para mostrar</p>
                    </div>
                )}
        </div>
    );
}
